<template>
  <div
    class="wt-story-duration"
    :title="'toolbox.videoDisplayTimeTooltip' | culture"
  >
    <span v-once>{{ 'toolbox.videoDisplayTime' | culture }}</span>
    &#160;
    <span v-text="durationString" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';

export default Vue.extend({
  name: 'wt-story-duration',

  computed: {
    durationString() {
      if (_.isDefined(this.finalStoryDuration)) {
        // note: chosen format doesn't displays hours if longer than that
        return moment.utc(this.finalStoryDuration * 1000).format('m:ss');
      } else {
        return '--:--';
      }
    },

    ...mapState({
      finalStoryDuration: (state) => state.story.finalStoryDuration,
    }),
  },
});
</script>

<style lang="scss" scoped>
.wt-story-duration {
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
